// extracted by mini-css-extract-plugin
export default {"footer":"MedicalNoteCancelAutoApproveWarningPopup_footer__IdnyY","paragraph":"MedicalNoteCancelAutoApproveWarningPopup_paragraph__ZAi3u"};